export const NAVBAR_HEIGHT = 108;
export const NAVBAR_HEIGHT_MOBILE = 70;
export const LIMITED_WIDTH = 680;
export const LIMITED_WIDTH_LARGE = 800;
